export let PurchaseActionTypes;
(function (PurchaseActionTypes) {
  PurchaseActionTypes["SetProductInfo"] = "[Purchase] Set Product Info";
  PurchaseActionTypes["SetAdditionalSeats"] = "[Purchase] Editing Seats";
  PurchaseActionTypes["SetHasSeatsChanged"] = "[Purchase] Set Has Seats Changed";
  PurchaseActionTypes["UpdateDtbId"] = "[Purchase] Update Dtb Id";
  PurchaseActionTypes["DtbIdIsUpToDate"] = "[Purchase] DtbId Is Up To Date";
})(PurchaseActionTypes || (PurchaseActionTypes = {}));